<template>
    <figure class="media-portal-item" :class="[bemFacet]">
        <div class="media-portal-item--wrap">
            <div class="media-portal-item--img" :style="content.url | bgImage" v-if="wasActivated">
                <img class="media-portal-item--img-el"
                        :src="content.url" :alt="content.alt">
            </div>
            <figcaption class="media-portal-item--description" v-if="content.description"
                    v-text="content.description">
            </figcaption>
        </div>

        <!-- <pre v-text="item"></pre> -->
    </figure>
</template>

<script>
    import mediaPortalItemMixin from 'framework/mixins/media-portal-item';


    export default {
        mixins: [
            mediaPortalItemMixin,
        ],
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/media-portal-item-image/index.vue?163c3fb8